import productCardSwiper from '../modules/productSwiper'

document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.collection-swiper', {
        loop: true,

        pagination: {
            el: '.main-pagination',
            clickable: true,

            renderBullet: function (index, className) {
                return '<div class="' + className + ' swiper-custom-line"></div>'
            },
        },

        navigation: {
            nextEl: '.collection-button-next',
            prevEl: '.collection-button-prev',
        },
    })

    new Swiper('.category-swiper', {
        slidesPerView: 4,
        spaceBetween: 8,
        slidesPerGroup: 1,

        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            600: {
                slidesPerView: 4,
            },
        },

        watchOverflow: false,
        preventInteractionOnTransition: true,
        rewind: false,

        navigation: {
            nextEl: '.category-button-next',
            prevEl: '.category-button-prev',
        },
    })
})
